import {Fetcher} from "openapi-typescript-fetch";
import type {paths} from "./types";

export const api = Fetcher.for<paths>();
